import { render, staticRenderFns } from "./ArmsRegArchiveUsageInfo.vue?vue&type=template&id=35adf482&scoped=true&"
import script from "./ArmsRegArchiveUsageInfo.vue?vue&type=script&lang=js&"
export * from "./ArmsRegArchiveUsageInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35adf482",
  null
  
)

export default component.exports